import {
  getUser,
  newUpload,
  savePurchase,
  updatePurchase,
  getPurchaseRequisition,
  setPurchaseRequisitionDetail
} from '@/api/sys/purchasing'
export default {
  namespaced: true,
  actions: {
    getUser({
      dispatch
    },
      params
    ) {
      return getUser(params)
        .then(res => {
          return res
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    purchasingImage({
      dispatch
    },
      params
    ) {
      return newUpload(params)
        .then(res => {
          return res
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    savePurchase({
      dispatch
    },
      data
    ) {
      return savePurchase(data)
        .then(res => {
          return res
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    updatePurchase({
      dispatch
    },
      data
    ) {
      return updatePurchase(data)
        .then(res => {
          return res
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    getPurchaseRequisition({
      dispatch
    },
      data
    ) {
      return getPurchaseRequisition(data)
        .then(res => {
          return res
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    setPurchaseRequisitionDetail({
      dispatch
    },
      data
    ) {
      return setPurchaseRequisitionDetail(data)
        .then(res => {
          return res
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },

  }
}
